import Auth from '@aws-amplify/auth';
import { LOCAL_STORAGE_KEY_PREFIX } from './local-storage';

const SIGNED_OUT_REDIRECT_PATH = '/login';
const COGNITO_DEVICE_CREDENTIAL_SUFFIXES = ['.deviceKey', '.deviceGroupKey', '.randomPasswordKey'];

const redirectToSignedOutEntryPage = (redirectPath: string) => {
  window.location.href = redirectPath;
};

const isCognitoDeviceCredential = (key: string) =>
  COGNITO_DEVICE_CREDENTIAL_SUFFIXES.some((suffix) => key.endsWith(suffix));

const clearClientAuthState = () => {
  // Clear sessionStorage cache
  sessionStorage.removeItem('cachedUserAttributes');
  sessionStorage.removeItem('cachedUserFetchTime');
  // Clear identity verification auto-open markers for this session.
  Object.keys(window.sessionStorage).forEach((key) => {
    if (key.startsWith('kyc-dialog-seen:')) {
      sessionStorage.removeItem(key);
    }
  });

  // Clear specific localStorage items (non-prefixed)
  localStorage.removeItem('shipmentDate');
  localStorage.removeItem('verificationClosed');
  localStorage.removeItem('rollo_local_provider');
  // localStorage.removeItem('isGrouped');

  // Clear all rsm1-* prefixed localStorage items
  // This includes: domesticCurrency, domesticCountryCode, unitMeasurement, user-sub
  Object.keys(window.localStorage).forEach((key) => {
    if (key.startsWith(LOCAL_STORAGE_KEY_PREFIX)) {
      localStorage.removeItem(key);
    }
  });

  // Clear Cognito session data while retaining device credentials used for trusted login.
  Object.keys(window.localStorage).forEach((key) => {
    if (key.includes('CognitoIdentityServiceProvider') && !isCognitoDeviceCredential(key)) {
      localStorage.removeItem(key);
    }
  });
};

/**
 * Centralized sign out function that clears session storage and caches while preserving
 * username-scoped Cognito device credentials used for trusted login.
 */
export const signOut = async (
  redirectPath: string | null = SIGNED_OUT_REDIRECT_PATH
): Promise<void> => {
  try {
    await Auth.signOut();
  } catch (error) {
    console.error('Error during sign out:', error);
  } finally {
    clearClientAuthState();
  }

  if (redirectPath) {
    redirectToSignedOutEntryPage(redirectPath);
  }
};
